import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const TOKEN_KEY = "auth_token";

const LogoutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem(TOKEN_KEY);
    navigate("/login", { replace: true });
  }, [navigate]);

  return null;
};

export default LogoutPage;

